// Libraries
import React from 'react';
import { currentLanguage } from 'i18n';
import _ from 'lodash';

// Utils
import { resolveHeaderDisplay } from 'common/utils/headerDisplay';

const locale = _.camelCase(window.gon.defaultLanguage || currentLanguage);

const Logo = () => {
  const { headerText, showLogo, showText } = resolveHeaderDisplay(gon.brand);

  return (
    <div className="logo">
      {gon.brand.logo_url ? (
        <a
          href={gon.brand.alternative_homepage_url || `/${locale}`}
          title={gon.brand.name_translations[currentLanguage]}
          aria-label={gon.brand.name_translations[currentLanguage]}
        >
          {showLogo && (
            <img alt={gon.brand.name_translations[currentLanguage]} src={gon.brand.logo_url} />
          )}
          {showText && <span className="logo__text">{headerText}</span>}
        </a>
      ) : (
        <div>
          <i className="fab fa-pagelines" />
          Our City Logo
        </div>
      )}
    </div>
  );
};

export default Logo;
